import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { IPlan } from "../../types/plan.type";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = `${import.meta.env.VITE_API_URL}/plans`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getPlans({
  status = [] as string[], 
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = "",
  orderBy = "",
  fields = "label,planType,value,deposit,months,status",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString()
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString()
    );

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPlan[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function createPlan(planData) {
  delete planData._id;
  const data = {
    ...planData,
    companyId: getCompanyId(),
  };
  const dataToUpdate = Object.assign({}, data, {
    planType: planData.planType["value"],
    status: planData.status["value"],
  });

  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dataToUpdate),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPlan>
  >;

  return result;
}

export async function updatePlan(planId: string, planData: IPlan) {
  const dataToUpdate = Object.assign({}, planData, {
    planType: planData.planType["value"],
    status: planData.status["value"],
  });

  const url = `${API_URL}/${planId}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dataToUpdate),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPlan>
  >;

  return result;
}

export type Period = {
  label: string;
  value: string;
  months: number;
  days?: number;
};

export type Addition = {
  plus: {
    label: string;
    value: number;
  };
};

const makeRequestPeriodsDebounced = createDebounce(makeRequest, 200);

export async function getPeriods() {
  const url = `${API_URL}/periods`;

  return makeRequestPeriodsDebounced(url) as Promise<ApiResponseType<Period[]>>;
}

export async function getAdditions() {
  const url = `${API_URL}/additions`;

  return makeRequestDebounced(url) as Promise<ApiResponseType<Addition[]>>;
}
